module.exports = __webpack_public_path__ + "img/server3.7d33ddf.png";